<button id="applyFromDetailBtnSlide" class="primaryButton ladda-button" [disabled]="(ApplyDifference<=0 && bLoggedIn)"
    *ngIf="((!Applied && bLoggedIn) || !bLoggedIn) && EnablePartialApplyQuestions=='yes' && showjobdetails && bJobDetailsShown && !((jobDetailFields == null || !jobDetailFields.isActive) && !solarErrorOccurred && partialApplyQuestions != '')"
    (click)="SlidePartialApplyQues()" role="button" aria-expanded="false" aria-controls="PartialApplyQuestions">
    {{'QuickApply'| translate}}
</button>

<div class="applyFlow partialApplyQuestions lightAccentBkg" id="PartialApplyQuestions"
    *ngIf="((!Applied && bLoggedIn) || !bLoggedIn) && EnablePartialApplyQuestions=='yes' && ((showjobdetails && bJobDetailsShown ) || bJobDetailsNextToSearchResultsShown) && !((jobDetailFields == null || !jobDetailFields.isActive) && !solarErrorOccurred) && workFlow !='apply' && partialApplyQuestions != ''"
    tabindex="0" aria-labelledby="applyForm">
    <h1 class="PartialApplyTitle" tabindex="-1">{{'QuickApply'|translate}}</h1>
    <a class="dialog-close" handle-spacebar="" aria-label="Close" role="button" (click)="$event.preventDefault(); SlidePartialApplyQues()"
        tabindex="0" href="#0"><span class="screenReaderText ng-binding">Close</span></a>
    <form name="applyForm" id="applyForm">
        <div id="partialApplyDom" ></div>
    </form>
</div>
